export { DMS_MODULE } from '../constants';

export const NAME = 'CustomerLeads';
export const ZakazkaNAME = 'Zakazka';
export enum LeadStatus {
	Won = 1,
	Lost = 2,
}
export enum LeadArea {
	Service = 1,
	Sales = 2,
}
export enum FollowupStatus {
	Open = 1,
	Closed = 2,
}
